import {connect, State} from '@modifi/redux'
import {compose} from 'ramda'
import {selectDialogData} from '@modifi/plugin-dialogs'
import ExitPromptDialog from './ExitPromptDialog'

const mapStateToProps = (state: State): {dialogData: any} => ({
  dialogData: selectDialogData(state),
})

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ExitPromptDialog)

export const DIALOG_NAME = 'onboarding/EXIT_PROMPT_DIALOG'
